import React from 'react';
import { ChevronRight } from 'lucide-react';
import { NxChip } from './NxChip';

const riskRing = {
  low:    'var(--nx-lime)',
  medium: 'var(--nx-amber)',
  high:   'var(--nx-red)',
};
const riskChipTone = {
  low: 'lime',
  medium: 'amber',
  high: 'red',
};

export function NxApplicantCard({ applicant, onOpen, active = false }) {
  const risk = applicant.risk || 'medium';
  const pct = Math.max(0, Math.min(100, applicant.progress_pct ?? 0));
  const ringColor = riskRing[risk];
  const initials = (applicant.name || '?').split(' ').filter(Boolean).slice(0,2).map(s => s[0]).join('').toUpperCase();
  const r = 35;
  const c = 2 * Math.PI * r;
  const off = c - (pct / 100) * c;

  return (
    <div
      className={`nx-aic ${active ? 'nx-aic--active' : ''}`}
      data-testid={`aic-${applicant.id}`}
      onClick={() => onOpen?.(applicant.id)}
      role="button"
      tabIndex={0}
    >
      <div className="nx-aic-avatar">
        <svg viewBox="0 0 76 76" aria-hidden="true">
          <circle cx="38" cy="38" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="3" />
          <circle
            cx="38" cy="38" r={r} fill="none"
            stroke={ringColor} strokeWidth="3"
            strokeDasharray={c} strokeDashoffset={off}
            strokeLinecap="round"
          />
        </svg>
        {applicant.photo_url ? (
          <img src={applicant.photo_url} alt={applicant.name || 'Applicant'} />
        ) : (
          <div className="nx-aic-avatar-fallback">{initials || '·'}</div>
        )}
      </div>

      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h4 className="nx-aic-name">{applicant.name || 'Unnamed Applicant'}</h4>
          {applicant.application_id && (
            <span className="nx-aic-sub">{applicant.application_id}</span>
          )}
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
          <span style={{ fontSize: 13.5, color: 'var(--nx-ink-soft)', fontWeight: 600 }}>
            {applicant.position || '—'}
          </span>
          {applicant.recruiter && (
            <span className="nx-aic-sub">Recruiter · {applicant.recruiter}</span>
          )}
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <NxChip tone="blue">{applicant.stage_label || applicant.stage || 'Stage'}</NxChip>
          <NxChip tone={riskChipTone[risk]}>Risk · {risk.toUpperCase()}</NxChip>
          <span className="nx-mono" style={{ fontSize: 11, color: 'var(--nx-ink-dim)', fontWeight: 600 }}>
            {pct}% complete
          </span>
        </div>
      </div>

      <button
        type="button"
        className="nx-btn nx-btn--icon"
        data-testid={`aic-menu-${applicant.id}`}
        onClick={(e) => { e.stopPropagation(); onOpen?.(applicant.id); }}
        aria-label="Open detail"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
